"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApartmentOptions = void 0;
// @ts-ignore
const javascript_natural_sort_1 = __importDefault(require("javascript-natural-sort"));
const apartmentLabel_1 = require("./apartmentLabel");
const createApartmentOptions = (companyApartments, buildings = []) => {
    const getApartmentLabel = (identifier, buildingUUID) => {
        const building = buildings.find((b) => b.uuid === buildingUUID);
        return (0, apartmentLabel_1.makeApartmentLabel)(identifier, building === null || building === void 0 ? void 0 : building.name);
    };
    return companyApartments
        .map(({ uuid, identifier, buildingUUID }) => ({
        label: getApartmentLabel(identifier, buildingUUID),
        value: uuid,
        identifier,
    }))
        .sort((a, b) => (0, javascript_natural_sort_1.default)(a.label, b.label));
};
exports.createApartmentOptions = createApartmentOptions;
